module.exports = __webpack_public_path__ + "static/media/create-feature-wc.2c361495.svg";